import { api } from '@/lib/api/client';

export interface QaReply {
  id: string;
  body: string;
  staff: boolean;
  createdAt: string;
  user: { name: string };
}

export interface QaThread {
  id: string;
  body: string;
  createdAt: string;
  user: { name: string; avatarInitials: string | null };
  replies: QaReply[];
}

export function getLessonQa(
  courseSlug: string,
  moduleOrder: number,
  lessonOrder: number,
): Promise<{ threads: QaThread[] }> {
  return api
    .get<{ threads: QaThread[] }>(`/courses/${courseSlug}/lessons/${moduleOrder}/${lessonOrder}/qa`)
    .then((r) => r.data);
}

export function askLessonQa(
  courseSlug: string,
  moduleOrder: number,
  lessonOrder: number,
  body: string,
): Promise<unknown> {
  return api
    .post(`/courses/${courseSlug}/lessons/${moduleOrder}/${lessonOrder}/qa`, { body })
    .then((r) => r.data);
}

export interface Ticket {
  id: string;
  ticketNo: string;
  subject: string;
  category: string;
  body: string;
  status: 'open' | 'progress' | 'resolved';
  createdAt: string;
  replies: QaReply[];
}

export function getTicketMeta(): Promise<{ categories: string[]; statuses: Record<string, string> }> {
  return api
    .get<{ categories: string[]; statuses: Record<string, string> }>('/tickets/categories')
    .then((r) => r.data);
}

export function getTickets(): Promise<{ tickets: Ticket[] }> {
  return api.get<{ tickets: Ticket[] }>('/tickets').then((r) => r.data);
}

export function createTicket(payload: { subject: string; category: string; body: string }): Promise<unknown> {
  return api.post('/tickets', payload).then((r) => r.data);
}

export function replyTicket(id: string, body: string): Promise<unknown> {
  return api.post(`/tickets/${id}/replies`, { body }).then((r) => r.data);
}

export function askDoubt(courseSlug: string, question: string): Promise<{ answered: boolean; reply: string }> {
  return api.post<{ answered: boolean; reply: string }>(`/courses/${courseSlug}/doubt`, { question }).then((r) => r.data);
}
